<template>
  <vx-card>
    <div class="flex pb-5">
      <div class="flex-1">
        {{ 'รายการทั้งหมด '+ borrowers.length }}
      </div>
    </div>
    <vs-table :data="borrowers">
      <template slot="thead">
<!--        <vs-th>ลำดับ</vs-th>-->
        <vs-th>เลขที่บัตรประชาชน</vs-th>
        <vs-th>ชื่อ-นามสกุล</vs-th>
        <vs-th>สถานะการศึกษา (มหาวิทยาลัย)</vs-th>
        <vs-th>วันที่ค้างชำระ</vs-th>
        <vs-th>จำนวนวันค้างชำระ</vs-th>
        <vs-th>ค่าธรรมเนียมคงเหลือ</vs-th>
        <vs-th>เบี้ยปรับคงเหลือ</vs-th>
        <vs-th>ยอดเรียกเก็บค้างชำระ</vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr v-for="(row) in data" :key="row.id">
          <!--          <vs-td class="text-center">-->
          <!--            {{ index  + 1}}-->
          <!--          </vs-td>-->
          <vs-td>
            <router-link :to="{ name: 'customer-borrower-search', params: {id: row.id}}">{{ row.idCardNumber }}</router-link>
          </vs-td>
          <vs-td>
            <router-link :to="{ name: 'customer-borrower-search', params: {id: row.id}}">{{ row.fullName }}</router-link>
          </vs-td>
          <vs-td>
            {{ row.educationStatusName }}
          </vs-td>
          <vs-td>
            {{ row.agingDate }}
          </vs-td>
          <vs-td class="text-right">
            {{ row.agingNumber }}
          </vs-td>
          <vs-td class="text-right">
            {{ row.accruedFeeRemain | numberFormat }}
          </vs-td>
          <vs-td class="text-right">
            {{ row.accruedPenaltyRemain | numberFormat }}
          </vs-td>
          <vs-td class="text-right">
            {{ row.outstandingAmountRemain | numberFormat }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </vx-card>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
const { mapActions: mapDashboardActions, mapState: mapDashboardState } = createNamespacedHelpers('Dashboard');
export default {
  name: 'DashboardFollowUpBorrowers',
 computed: {
    ...mapDashboardState(['dashboardFollowUpBorrowers']),
    borrowers() {
      return this.dashboardFollowUpBorrowers;
    },
  },
  methods: {
    ...mapDashboardActions(['getDashboardFollowUpBorrowers']),
  },
  async created() {
    this.$vs.loading()
    await this.getDashboardFollowUpBorrowers({
       id: this.$route.params.id
    });
    setTimeout(() => {
      this.$vs.loading.close()
    }, 150)
  },
}
</script>

<style scoped>
</style>
